import { render, staticRenderFns } from "./switch-widget.vue?vue&type=template&id=4430e060&scoped=true&"
import script from "./switch-widget.vue?vue&type=script&lang=js&"
export * from "./switch-widget.vue?vue&type=script&lang=js&"
import style0 from "./switch-widget.vue?vue&type=style&index=0&id=4430e060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4430e060",
  null
  
)

export default component.exports